// extracted by mini-css-extract-plugin
module.exports = {"qualitySelector":"fs","label":"ft","downloadSize":"fu","selectorWrapper":"fv","selected":"fw"};